import { render, staticRenderFns } from "./ResourcesItem.vue?vue&type=template&id=62eaddbc&"
import script from "./ResourcesItem.vue?vue&type=script&lang=ts&"
export * from "./ResourcesItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImg: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonImg.vue').default})
